<template>
  <div class="mb-0">
    <form-wizard ref="workflowProgress" title="" subtitle="" :start-index="startingIndex" shape="tab">
      <template slot="step" scope="props">
        <wizard-step :tab="props.tab" :transition="props.transition" :key="props.tab.title" :index="props.index">
        </wizard-step>
      </template>
      <template v-for="(step,index) in steps">
        <tab-content :title="step.name">
          <!-- <b-row align-h="center"> -->
          <span></span>
          <!-- <div class="w-75"> -->
          <!-- <component :is="step.component"></component> -->
          <!-- </div> -->
          <!-- </b-row> -->
        </tab-content>
      </template>
      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left">
          <!-- <wizard-button @click.native="props.prevTab()" :style="props.fillButtonStyle">Previous</wizard-button> -->
        </div>
        <div class="wizard-footer-right">
          <!-- <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">{{$t("fitComponents.components.fitWorkflowProgress.next")}}</wizard-button>
          <wizard-button v-else @click.native="alert('Done')" class="wizard-footer-right finish-button" :style="props.fillButtonStyle"> {{props.isLastStep ? 'Done' : $t("fitComponents.fitWorkflowProgress.next")}}</wizard-button> -->
        </div>
      </template>
    </form-wizard>
  </div>
</template>
<script type="text/javascript">
import { FormWizard, TabContent, WizardButton, WizardStep } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
export default {
  name: 'FITWorkflowProgressbar',
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    startingIndex: { type: Number }
  },
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    WizardStep,
  },
  methods: {
    nextTab() {
      this.$refs.workflowProgress.nextTab();
    },
    prevTab() {
      this.$refs.workflowProgress.prevTab();
    }
    // validateAsync(success,error){
    //   return new Promise((resolve,reject)=>{

    //   })
    // }
  },
  data() {
    return {

    }
  },
  created() {

  },
}

</script>



// WEBPACK FOOTER //
// src/components/Form/FITWorkflowProgressbar.vue